import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { LocalStorageService } from "angular-2-local-storage";

// Import Model
import { CompanyManagelistModel } from "../../../model/jubili/company-manage/company-list";
import { CompanyListModel } from "../../../model/jubili/company-manage/company-index";
import { SortCompanyModel } from "../../../model/jubili/company-manage/company-sort";

// Import Enum
import { SortType } from "../../../enum/jubili/company-manage/sort-type";
// import { AddressInformationComponent} from "../../shared/jubili-address/address-information.component";
import { CompanyManageService } from "../../../service/api/jubili/company-manage.service";
import { AuthenticationService } from "../../../service/api/auth/auth.service";
import { UpdateSwitchCompanyModel } from "../../../model/jubili/company-manage/update-switch-company.model";
import { formatDate } from "@angular/common";

@Component({
    selector: "bo-jub-company-manage",
    templateUrl: "./company-manage.component.html",
    styleUrls: ["./company-manage.component.scss"],
    providers: [CompanyManageService]
})

export class CompanyManageComponent implements OnInit {

    constructor(
        private router: Router,
        private localStorageService: LocalStorageService,
        private companyManageService: CompanyManageService,
        private AuthService: AuthenticationService
    ) { }

    companypageList: Array<CompanyManagelistModel> = new Array<CompanyManagelistModel>();
    companyIndex: CompanyListModel = new CompanyListModel();
    // using for page list (default)
    page: number = 1;
    lastPage: number = 1;
    limit: number = 50;
    countall: number = 0;
    countNew: number = 0;
    countOld: number = 0;
    countTotal: number = 0;
    countNotAvailable: number = 0;
    companySurrkey: number = 0;
    qoPhotoModel: UpdateSwitchCompanyModel =new  UpdateSwitchCompanyModel();
    activeLocationFeatureModel: UpdateSwitchCompanyModel =new  UpdateSwitchCompanyModel();
    datawarehouseModel: UpdateSwitchCompanyModel =new  UpdateSwitchCompanyModel();
    imageSrc: string = "";

    // using for sort (default)
    sortCol: string = "createdate";
    sortType: number = SortType.DESC;

    // using for change grade
    gradeCompany: string = "";

    // using for change page
    pagelist: number = 0;
    limitlist: number = 0;

    // using search company
    companyName = "";
    companysearch: string = "";
    searchcompany: string = "";

    // using filter
    isbadgefill: number = 0;
    ishidefill: number = 0;
    isgradefill: number = 0;
    isQoPhotofill: number = 0;
    isActiveLocationFeaturefill: number = 0;
    filterValueGrade: string = "";
    filterValueIsbadge: string = "";
    filterValueHide: string = "";
    filterValueIsQoPhoto: string = "";
    filterValueIsActiveLocationFeature: string = "";
    filterCountry: string = "";
    isbadge: string = "";
    Country: string = "";
    filterProvince: string = "";
    filterDistrict: string = "";
    companyCountStatus: string = '0';
    filterIsNew: string = "";
    filterIsAvailable: string = "";

    isExporting: boolean = false;

    model : UpdateSwitchCompanyModel = new  UpdateSwitchCompanyModel;

    ngOnInit(): void {
        this.countCompanyStatus();
        this.setdatacompanylist();
        this.goTofirstPage();
    }

    countCompanyStatus(): void {
        this.companyManageService.countCompanyStatus(this.companysearch, this.filterValueGrade,
            this.filterValueIsbadge, this.filterValueHide, this.filterValueIsQoPhoto, this.filterValueIsActiveLocationFeature, this.filterIsAvailable, this.filterIsNew, this.filterCountry, this.filterProvince,
             this.filterDistrict).subscribe(
            response => {
                this.countTotal = response.countAll;
                this.countNew = response.countNew;
                this.countOld = response.countOld;
                this.countNotAvailable = response.countNotAvailable;
            }
        )
    }

    setdatacompanylist(): void {
        this.pagelist = ((this.page - 1) * 50) + 1;
        this.limitlist = this.limit * this.page;
        this.companyManageService.getCompanyBackOffice(this.companysearch, this.filterValueGrade,
          this.filterValueIsbadge, this.filterValueHide, this.filterValueIsQoPhoto, this.filterValueIsActiveLocationFeature, this.filterIsAvailable, this.filterIsNew, this.filterCountry, this.filterProvince,
           this.filterDistrict, this.limitlist, this.pagelist, this.sortCol, this.sortType)
           .subscribe(
            Response => {
                this.companyIndex = Response;
                this.companypageList = this.companyIndex.data; // set data to show list
                this.countall = this.companyIndex.count;
                this.lastPage = Math.ceil((this.companyIndex.count) / (this.limit));
                this.countCompanyStatus();
                //this.goTofirstPage();
            },
            err => {
                // unauthorized refresh token
                console.log("unauth");
                if (err.status === 401) {
                    this.AuthService.refreshSessionToken()
                    .subscribe(
                        Response => {
                            // Update session
                            this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);
                            this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);

                            this.setdatacompanylist();
                        }
                    );
                } else {
                    this.router.navigate(["/home"]);
                }
            }
        );
    }

    // set hide company
    updateHideCompany(hidecompany: number, companySurr: number): void {
        this.companyManageService.updateHideCompanyBackOffice(hidecompany, companySurr)
        .subscribe(
            Response => {
                console.log(Response);
            }
        );
        this.sortCol = "createdate";
        this.sortType = SortType.DESC;
        // this.setdatacompanylist();
    }

    // set badge company
    updateBadgeCompany(badgecompany: number, companySurr: number): void {
        this.companyManageService.updateBadgeCompanyBackOffice(badgecompany, companySurr)
        .subscribe(
            Response => {
                console.log(Response);
            }
        );
        this.sortCol = "createdate";
        this.sortType = SortType.DESC;
        // this.setdatacompanylist();
    }

    updateSwitchBackOffice(data:UpdateSwitchCompanyModel): void {
        this.companyManageService.updateSwitchBackOffice(data)
        .subscribe(
            Response => {
                this.setdatacompanylist();
            }
        );
        this.sortCol = "createdate";
        this.sortType = SortType.DESC;
    }

    // // set is qo photo company
    // updateQoPhotoCompany(qoPhotocompany: number, companySurr: number): void {
    //     const index = this.companyIndex.data.findIndex(item => {
    //         return item.companySurrKey == companySurr;
    //     });
    //    if( this.companyIndex.data[index].isQoPhoto !=  Boolean(qoPhotocompany)){
    //     this.qoPhotoModel.companySurr =companySurr;
    //     this.qoPhotoModel.valueCompany = qoPhotocompany;
    //     this.companyManageService.updateQoPhotoCompanyBackOffice(this.qoPhotoModel)
    //     .subscribe(
    //         Response => {
    //             console.log(Response);
    //         }
    //     );
    //     this.sortCol = "createdate";
    //     this.sortType = SortType.DESC;
    //    }else{
    //        console.log("ไม่เปลี่ยนค่า QoPhoto")
    //    }

    //     // this.setdatacompanylist();
    // }


    // updateDataWarehouse(dataWarehouseCompany: number, companySurr: number): void {
    //     const index = this.companyIndex.data.findIndex(item => {
    //         return item.companySurrKey == companySurr;
    //     });
    //     if( this.companyIndex.data[index].isDatawarehouse !=  Boolean(dataWarehouseCompany)){
    //     this.datawarehouseModel.companySurr = companySurr;
    //     this.datawarehouseModel.valueCompany = dataWarehouseCompany;
    //     this.companyManageService.updateDataWarehouseBackOffice(this.datawarehouseModel)
    //     .subscribe(
    //         Response => {
    //             console.log(Response);
    //         }
    //     );
    //     this.sortCol = "createdate";
    //     this.sortType = SortType.DESC;
    //     }else{
    //         console.log("ไม่เปลี่ยนค่า DataWareHouse")
    //     }
    //     // this.setdatacompanylist();
    // }

    // // set is active location feature company
    // updateActiveLocationFeatureCompany(activeLocationFeaturecompany: number, companySurr: number): void {
    //     const index = this.companyIndex.data.findIndex(item => {
    //         return item.companySurrKey == companySurr;
    //     });
    //     if( this.companyIndex.data[index].isActiveLocationFeature !=  Boolean(activeLocationFeaturecompany)){
    //     this.activeLocationFeatureModel.companySurr = companySurr;
    //     this.activeLocationFeatureModel.valueCompany = activeLocationFeaturecompany;
    //     this.companyManageService.updateActiveLocationFeatureCompanyBackOffice(this.activeLocationFeatureModel)
    //     .subscribe(
    //         Response => {
    //             console.log(Response);
    //         }
    //     );
    //     this.sortCol = "createdate";
    //     this.sortType = SortType.DESC;
    //     }else{
    //         console.log("ไม่เปลี่ยนค่า Location")
    //     }
    //     // this.setdatacompanylist();
    // }

    // get data company for search
    searchCompanylist(): void {
        this.companysearch = this.searchcompany;
        this.setdatacompanylist();
        this.countCompanyStatus();
        this.goTofirstPage();
    }

    // sort company list
    sortList(event: SortCompanyModel): void {
        this.sortCol = event.sortCol;
        this.sortType = event.sortType;
        this.gradeCompany = event.gradecompany;

        if (event.hidecompany !== 5) {
            // this.updateHideCompany(event.hidecompany, event.companyhideSurrKey);
            this.sortCol = "createdate";
            this.sortType = SortType.DESC;
        }
        if (event.badgecompany !== 5) {
            // this.updateBadgeCompany(event.badgecompany, event.companybadgeSurrKey);
            this.sortCol = "createdate";
            this.sortType = SortType.DESC;
        }

        if(event.isEditFeature){
            this.model.qoPhoto = event.qoPhotocompany;
            this.model.location = event.activeLocationFeaturecompany;
            this.model.dataWarehouse = event.dataWareHousecompany;
            this.model.companySurr = event.companySurrkey;
            this.model.isChange = true;
            this.model.isAvailable = event.isAvailable;
            this.model.isBadge = event.isBadge;
            this.model.isHide = event.isHide;
            this.model.isActiveLocationOffLimit = event.isActiveLocationOffLimit;
            this.model.isGeoMap = event.isGeoMap;
            this.model.isAccessWebhook = event.isAccessWebhook;
            this.updateSwitchBackOffice(this.model);
        }


        // if(event.qoPhotocompany !== 5||event.activeLocationFeaturecompany !== 5||event.dataWareHousecompany !== 5){
        //     this.model.isChange = false;
        //     if(event.qoPhotocompany!= this.model.qoPhoto){
        //         this.model.qoPhoto = Number(event.qoPhotocompany);
        //         this.model.companySurr = event.companyQoPhotoSurrKey;
        //         this.model.isChange = true;
        //     }
        //     if(event.activeLocationFeaturecompany != this.model.location){
        //         this.model.location = Number(event.activeLocationFeaturecompany);
        //         this.model.companySurr = event.companyActiveLocationFeatureSurrKey;
        //         this.model.isChange = true;
        //     }
        //     if(event.dataWareHousecompany != this.model.dataWarehouse){
        //         this.model.dataWarehouse = Number(event.dataWareHousecompany);
        //         this.model.companySurr = event.companyDataWareHouse;
        //         this.model.isChange = true;
        //     }
        //     if(this.model.isChange){
        //         this.updateSwitchBackOffice(this.model);
        //     }
        // }
      this.page = 1;
        this.setdatacompanylist();
    }

    // filter isbadge company list
    filterIsbadge(): void {
        if (this.isbadgefill.toString() === "1") { this.filterValueIsbadge = "1"; }
        else if (this.isbadgefill.toString() === "2") { this.filterValueIsbadge = "0"; }
      else { this.filterValueIsbadge = ""; }

      this.page = 1;
        this.setdatacompanylist();
    }

    // filter isgrade company list
    filterIsgrade(): void {
        // Active=0,Non-Active=1,Hold=2,Terminate=3
        if (this.isgradefill.toString() === "1") { this.filterValueGrade = "0"; }
        else if (this.isgradefill.toString() === "2") { this.filterValueGrade = "1"; }
        else if (this.isgradefill.toString() === "3") { this.filterValueGrade = "2"; }
        else if (this.isgradefill.toString() === "4") { this.filterValueGrade = "3"; }
      else { this.filterValueGrade = ""; }

      this.page = 1;
        this.setdatacompanylist();
    }

    // filter ishide company list
    filterIshide(): void {
        if (this.ishidefill.toString() === "1") { this.filterValueHide = "1"; }
        else if (this.ishidefill.toString() === "2") { this.filterValueHide = "0"; }
      else { this.filterValueHide = ""; }

      this.page = 1;
        this.setdatacompanylist();
    }

    // filter isQoCompany company list
    filterIsQoPhoto(): void {
        if (this.isQoPhotofill.toString() === "1") { this.filterValueIsQoPhoto = "1"; }
        else if (this.isQoPhotofill.toString() === "2") { this.filterValueIsQoPhoto = "0"; }
      else { this.filterValueIsQoPhoto = ""; }

      this.page = 1;
        this.setdatacompanylist();
    }

    // filter isActive Location company list
    filterIsActiveLocationFeature(): void {
        if (this.isActiveLocationFeaturefill.toString() === "1") { this.filterValueIsActiveLocationFeature = "1"; }
        else if (this.isActiveLocationFeaturefill.toString() === "2") { this.filterValueIsActiveLocationFeature = "0"; }
      else { this.filterValueIsActiveLocationFeature = ""; }

      this.page = 1;
        this.setdatacompanylist();
    }

    backPage(): void {
        if (this.page > 1) {
            this.page--;
            this.setdatacompanylist();
        }
    }

    nextPage(): void {
        if (this.page < this.lastPage) {
            this.page++;
            this.setdatacompanylist();
        }
    }

    goTofirstPage(): void {
        if (this.page > 1) {
            this.page = 1;
            this.setdatacompanylist();
        }
    }

    goTolastPage(): void {
        if (this.page < this.lastPage) {
            this.page = this.lastPage;
            this.setdatacompanylist();
        }
    }

    getfilteraddress(value: any): void {
        console.log(value);
        this.filterCountry = value.country;
        this.filterProvince = value.province;
      this.filterDistrict = value.district;
      this.page = 1;
        this.setdatacompanylist();
    }
    changeCompanyCountStatus(data: string) {
        this.filterIsNew = "";
        this.filterIsAvailable = "";
        this.companyCountStatus = data;
        if (this.companyCountStatus.toString() === "1") { this.filterIsNew = "1"; }
        if (this.companyCountStatus.toString() === "2") { this.filterIsNew = "0"; }
        if (this.companyCountStatus.toString() === "3") { this.filterIsAvailable = "0"; }

      this.page = 1;
        this.setdatacompanylist();
        // this.redirectPage();
      }

    exportCompanyLicense(): void {
        this.isExporting = true;
        this.companyManageService.exportCompanyLicense(
            this.companysearch,
            this.filterValueGrade,
            this.filterValueIsbadge,
            this.filterValueHide,
            this.filterValueIsQoPhoto,
            this.filterValueIsActiveLocationFeature,
            this.filterIsAvailable,
            this.filterIsNew,
            this.filterCountry,
            this.filterProvince,
            this.filterDistrict,
            this.limitlist,
            this.pagelist,
            this.sortCol,
            this.sortType
        ).subscribe((res) => {
            const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = "company_license_" + formatDate(Date(), 'ddMMyyyy', 'en-US') + ".xlsx";
            a.click();
            window.URL.revokeObjectURL(url);
            this.isExporting = false;
            a.remove();
        }, (err) => {
            this.isExporting = false;
            alert("Error Message : " + err.message);
        }, () => {
            this.isExporting = false;
        });
    }
}
